module.exports = __webpack_public_path__ + "img/envelope.cd7242f3.svg";